export default __webpack_public_path__ + "static/media/GothamSSm-Light.d814f4fa.woff";